export default __webpack_public_path__ + "static/media/regulatory--no-mopeds-or-bicycles--g1.72ce756c.png";